import { useQuery } from '@tanstack/react-query'
import { fiiAnalysisService } from '@/services'
import { fiiAnalysisQueryKeys } from './query-keys'

export const useGetFiiAnalysisQuery = (ticker: string, enabled = true) => {
  return useQuery({
    queryKey: fiiAnalysisQueryKeys.detail(ticker),
    queryFn: () => fiiAnalysisService.getByTicker(ticker),
    enabled: !!ticker && enabled,
    staleTime: 1000 * 60 * 60, // 1h — dados mudam no máximo uma vez por dia
  })
}
